import { render } from "./AppPanelMenuSub.vue?vue&type=template&id=2069a63a"
import script from "./AppPanelMenuSub.vue?vue&type=script&lang=js"
export * from "./AppPanelMenuSub.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__